<template>
  <section class="container-fluid">
    <div>
      <div class="mb-4 text-center">
        <h1>Required Training</h1>
      </div>
      <div>
        <grid
          :entityTypeId="entityTypeId"
          :formId="formId"
          :entityTypeName="entityTypeName"
          :primaryEntity="primaryentity"
          :showLastUpdated="showLastUpdated"
          :showFormOnEmpty="true"
          :showComments="true"
          :basePageSize="gridPageSize"
          :baseCurrentPage="gridCurrentPage"
          @setPageSize="setPageSize"
          @setCurrentPage="setCurrentPage"
        >
        </grid>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PDPRequiredTraining',
  data() {
    return {
      entityTypeId: 11,
      formId: 10,
      entityTypeName: 'PDP Required Training',
      showLastUpdated: true,
      gridPageSize: 5,
      gridCurrentPage: 1
    };
  },
  props: {
    primaryentity: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    setPageSize(size) {
      this.gridPageSize = parseInt(size);
    },
    setCurrentPage(page) {
      this.gridCurrentPage = parseInt(page);
    }
  }
};
</script>
